module.exports = "/fonts/vendor/tinymce/skins/lightgray/tinymce.woff?50c955d592e8a54a0e4cb4936d386076";